export default __webpack_public_path__ + "static/media/roadmap_4.08b4cae4.png";